var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1052,
    height: 152,
    viewBox: "0 0 1052 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1052,
    height: 152,
    fill: "#F10000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M899.785 31.73H885.495V120.28H899.785V31.73Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M899.605 31.93H885.665V120.09H899.605V31.93Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M965.225 40.9L990.435 84.94H939.665L965.225 40.9ZM972.285 31.72H958.465L906.395 120.27H919.255L934.855 93.37H995.275L1010.55 120.27H1024.36L972.285 31.72Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M965.225 41.07L990.315 84.89H939.815L965.225 41.07ZM972.265 31.92H958.505L906.735 120.08H919.515L935.025 93.29H995.115L1010.3 120.08H1024.04L972.265 31.92Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.455 40.91L111.685 84.93H60.915L86.455 40.91ZM93.535 31.72H79.695L27.645 120.27H40.495L56.085 93.36H116.505L131.775 120.27H145.585L93.535 31.72Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.455 41.07L111.545 84.89H61.045L86.455 41.07ZM93.495 31.92H79.735L27.965 120.08H40.745L56.255 93.29H116.345L131.525 120.08H145.265L93.495 31.92Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.455 40.91L111.685 84.93H60.915L86.455 40.91ZM93.535 31.72H79.695L27.645 120.27H40.495L56.085 93.36H116.505L131.775 120.27H145.585L93.535 31.72Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.455 40.97L111.625 84.91H60.965L86.455 40.97ZM93.515 31.8H79.705L27.775 120.19H40.595L56.155 93.33H116.445L131.685 120.19H145.465L93.515 31.8Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M256.195 31.72H244.475V107.38H244.155L165.075 31.72H150.985V120.27H162.705V44.63H163.025L242.575 120.27H256.195V31.72Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M256.025 31.92H244.345V107.25H244.025L165.205 31.92H151.155V120.08H162.845V44.77H163.155L242.445 120.08H256.025V31.92Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M378.865 31.72H367.145V107.38H366.835L287.755 31.72H273.655V120.27H285.385V44.63H285.695L365.255 120.27H378.865V31.72Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M378.695 31.92H367.015V107.25H366.705L287.875 31.92H273.825V120.08H285.515V44.77H285.825L365.125 120.08H378.695V31.92Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M443.075 40.91L468.305 84.93H417.535L443.075 40.91ZM450.135 31.72H436.315L384.265 120.27H397.115L412.705 93.36H473.125L488.395 120.27H502.205L450.135 31.72Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M443.075 41.07L468.165 84.89H417.665L443.075 41.07ZM450.095 31.92H436.355L384.585 120.08H397.365L412.875 93.29H472.975L488.155 120.08H501.895L450.105 31.92H450.095Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M641.325 31.72H624.795L574.695 108.74L524.615 31.72H507.605V120.27H519.265V43.63H519.585L569.035 120.27H579.755L629.355 43.75H629.685V120.27H641.325V31.72Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M641.155 31.92H624.665L574.695 108.6L524.745 31.92H507.775V120.08H519.405V43.77H519.725L569.045 120.08H579.735L629.215 43.9H629.545V120.08H641.155V31.92Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M705.535 40.91L730.765 84.93H679.995L705.535 40.91ZM712.615 31.72H698.785L646.735 120.27H659.595L675.175 93.36H735.595L750.865 120.27H764.675L712.615 31.72Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M705.535 41.07L730.625 84.89H680.125L705.535 41.07ZM712.575 31.92H698.815L647.045 120.08H659.835L675.335 93.29H735.435L750.615 120.08H764.355L712.575 31.92Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M771.915 31.72H835.285C854.985 31.72 873.085 37.05 873.085 55.65C873.085 65.09 865.425 74.51 850.275 77.11V77.36C866.725 79.35 870.135 87.41 870.965 101.92C871.295 107.5 872.265 118.28 875.035 120.27H862.005C859.875 118.42 859.075 111.84 858.905 102.17C858.575 86.54 850.775 81.32 830.735 81.32H783.985V120.27H771.925V31.72H771.915ZM783.975 72.89H834.955C848.145 72.89 860.035 69.17 860.035 55.65C860.035 42.13 847.175 40.15 836.095 40.15H783.975V72.89Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M772.085 31.92H834.985C854.535 31.92 872.505 37.23 872.505 55.74C872.505 65.13 864.905 74.51 849.865 77.11V77.36C866.195 79.34 869.575 87.37 870.395 101.81C870.725 107.37 871.685 118.1 874.435 120.08H861.505C859.395 118.24 858.595 111.68 858.425 102.06C858.105 86.49 850.355 81.31 830.455 81.31H784.045V120.08H772.075V31.92H772.085ZM784.055 72.91H834.665C847.765 72.91 859.565 69.21 859.565 55.75C859.565 42.29 846.805 40.32 835.795 40.32H784.065V72.91H784.055Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.20801dfff1bc5cce9e0abcfd259595d4.svg";
export { ForwardRef as ReactComponent };